/**
 * Text utility functions for safe text transformations
 */

/**
 * Converts a name from all caps to proper case while preserving Spanish accents and special characters
 * @param name - The name in all caps (e.g., "SEBASTIÁN")
 * @returns The name in proper case (e.g., "Sebastián")
 */
export const toProperCase = (name: string): string => {
  if (!name || typeof name !== 'string') {
    return name;
  }

  // Split by spaces to handle multiple words
  return name
    .split(' ')
    .map(word => {
      if (!word) return word;
      
      // Convert to lowercase first to preserve accents
      const lowerWord = word.toLowerCase();
      
      // Capitalize the first character while preserving accents
      return lowerWord.charAt(0).toUpperCase() + lowerWord.slice(1);
    })
    .join(' ');
};

/**
 * Extracts the first name from a full name and converts it to proper case
 * @param fullName - The full name (e.g., "SEBASTIÁN GONZÁLEZ")
 * @returns The first name in proper case (e.g., "Sebastián")
 */
export const getFirstName = (fullName: string): string => {
  if (!fullName || typeof fullName !== 'string') {
    return 'Administrator';
  }

  const firstName = fullName.split(' ')[0];
  return toProperCase(firstName);
};

/**
 * Converts a full name to proper case
 * @param fullName - The full name in all caps (e.g., "SEBASTIÁN GONZÁLEZ")
 * @returns The full name in proper case (e.g., "Sebastián González")
 */
export const getFullName = (fullName: string): string => {
  if (!fullName || typeof fullName !== 'string') {
    return fullName;
  }

  return toProperCase(fullName);
};
